/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowbrandcoloredit4Inputs */

const en_aiflowbrandcoloredit4 = /** @type {(inputs: Aiflowbrandcoloredit4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change colour`)
};

const de_aiflowbrandcoloredit4 = /** @type {(inputs: Aiflowbrandcoloredit4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Farbe ändern`)
};

/**
* | output |
* | --- |
* | "Change colour" |
*
* @param {Aiflowbrandcoloredit4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowbrandcoloredit4 = /** @type {((inputs?: Aiflowbrandcoloredit4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowbrandcoloredit4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowbrandcoloredit4(inputs)
	return de_aiflowbrandcoloredit4(inputs)
});
export { aiflowbrandcoloredit4 as "aiFlowBrandColorEdit" }